














import { Component, Prop, Vue } from 'vue-property-decorator';
import { ContactBlockDto } from '@/api';

@Component({
  components: {},
})
export default class ContactBlock extends Vue {
  @Prop({required: true})
  public readonly model!: ContactBlockDto;

  get imageLocation(): string {
    return this.model.imagePath;
  }
}
